import { useCallback, useEffect } from "react";
import { useSearchParams } from "react-router";
import { VARIANT_KEYS, VARIANT_META } from "./hrpReconciliationMockData";

/** PROTOTYPE — floating variant switcher. Hidden in production builds. */
const PrototypeVariantSwitcher = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const current = searchParams.get("variant") ?? "A";
    const index = Math.max(0, VARIANT_KEYS.indexOf(current));
    const meta = VARIANT_META[current] ?? VARIANT_META.A;

    const cycle = useCallback((delta) => {
        setSearchParams((prev) => {
            const idx = Math.max(0, VARIANT_KEYS.indexOf(prev.get("variant") ?? "A"));
            const nextIndex = (idx + delta + VARIANT_KEYS.length) % VARIANT_KEYS.length;
            const next = new URLSearchParams(prev);
            next.set("prototype", "reconciliation");
            next.set("variant", VARIANT_KEYS[nextIndex]);
            return next;
        }, { replace: true });
    }, [setSearchParams]);

    useEffect(() => {
        const onKeyDown = (e) => {
            if (e.target?.matches("input, textarea, [contenteditable=true]")) return;
            if (e.key === "ArrowLeft") cycle(-1);
            if (e.key === "ArrowRight") cycle(1);
        };
        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    }, [cycle]);

    if (import.meta.env.PROD) return null;

    return (
        <div className="billing-rate-builder__prototype-switcher" role="toolbar" aria-label="Prototype variant switcher">
            <button type="button" onClick={() => cycle(-1)} aria-label="Previous variant">←</button>
            <span>{meta.label}</span>
            <button type="button" onClick={() => cycle(1)} aria-label="Next variant">→</button>
        </div>
    );
};

export default PrototypeVariantSwitcher;
